export const CUSTOM_FIELDS_MAP = {
  websiteCorrectionAbout: "14352825132433",
  url: "14352913605265",
};
export const BASE_URL =
  "https://support.lonelyplanet.com/hc/en-us/requests/new";

export const TICKET_FORM_ID = "14352335019537";
